import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RepublicaMovilService } from '../../services/republica-movil.service';
import { RmDraftService } from '../../services/rm-draft.service';
import { RmOrderService } from '../../services/rm-order.service';
import { orderType, superStatus } from 'src/app/shared/constantes';
import { priceWithIVA } from 'src/app/utils/priceWithIVA';
import { RmGlobals } from '../../classes/rm-globals';
import { RmNormalizadorService } from '../../services/rm-normalizador.service';
import { Subscription } from 'rxjs';

const typeReProcess = {
    full: 'full',
    partial: 'partial',
    onlyClient: 'cliente'
}

@Component({
    selector: 'app-rm-modal-reprocess',
    templateUrl: './rm-modal-reprocess.component.html',
    styleUrls: ['./rm-modal-reprocess.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmModalReprocessComponent implements OnInit, OnDestroy {
    @Input() order: any;
    @Input() pdv: any;
    @Input() rates: any;
    @Input() showOptionClient: boolean = true;
    public typeReProcess = typeReProcess;
    public showConvergente: boolean = true;
    public showMovil: boolean = true;
    public showFibra: boolean = true;
    public orderType = orderType;
    public loading: boolean = false;
    public loadingText: string = 'Obteniendo datos del cliente...';
    public superStatus: any = superStatus;
    public errorOrder: boolean = false;
    public anyRateInvalid: boolean = false;
    public roadTypes: any[];
    public selected: any = {
        type: typeReProcess.full,
        countCanceledProduct: 0,
        elements: {
            fibra: false,
            movil: [],
            cliente: true,
        }
    }
    private allSubscription: Subscription[] = [];

    constructor(
        private router: Router,
        public activeModal: NgbActiveModal,
        private rmService: RepublicaMovilService,
        private orderService: RmOrderService,
        private draftService: RmDraftService,
        public rmGlobals: RmGlobals
    ) { }

    ngOnInit(): void {
        this.loading = true;
        if (!this.order.order_id) {
            this.orderService.getOrderFromService(this.order)
                .subscribe((data: any) => {
                    if (data && data.msg && data.msg) {
                        this.order = data.msg;
                        this.initOrder();
                    };
                }, (error) => {
                    this.errorOrder = true;
                });
        } else {
            this.initOrder();
        }

        this.allSubscription.push(this.rmService.getCommonRoadTypes()
            .subscribe((data: any) => {
                if (data) {
                    this.roadTypes = data;
                }
            })
        );

    }

    initOrder() {
        if (this.order && this.order.mobiles && this.order.mobiles.length) {
            this.selected.elements.movil = this.order.mobiles.map(x => false);
        }

        // Obtenemos el número de productos cancelados que tenemos
        this.selected.countCanceledProduct = 0;
        if (this.order && this.order.super_status === superStatus.cancelled) {
            if (this.order.broadband) {
                this.selected.countCanceledProduct++;
                this.anyRateInvalidOrder(this.order.type);
            }
            if (this.order.mobiles && this.order.mobiles.length > 0) {
                this.selected.countCanceledProduct += this.order.mobiles.length;
                this.anyRateInvalidOrder(this.order.type);         
            }
        }

        if (this.showOptionClient) {
            this.selected.type = typeReProcess.onlyClient;
        }
        this.loading = false;
    }

    async copyOrderFull() {
        let path;
        const mobileForms = [];
        const forms = {
            fibra: null,
            movilPacks: null,
            cliente: null,
            normalizador: null,
            cobertura: null,
            disabledCliente: true,
            haveCoverage: true
        };

        if (this.order.broadband) {
            this.loading = true;
            this.loadingText = 'Comprobando cobertura...';
            forms.haveCoverage = await this.rmGlobals.coverageIsValid(this.order.broadband, this.roadTypes);
            if (forms.haveCoverage) {
                forms.fibra = {
                    rate: this.rmGlobals.ftthRateIsValid(this.order, this.rates) ? this.draftService.getRate(this.order.broadband.rate) : null
                };
            } else {
                forms.fibra = {
                    rate: null
                };
            }
            forms.normalizador = this.draftService.getNormalizador(this.order.broadband);
            forms.cobertura = this.draftService.getCobertura(this.order.broadband);
        }

        if (this.order.mobiles && this.order.mobiles.length > 0) {
            this.order.mobiles.forEach((item: any, index) => {
                // Miramos si la tarifa seleccionada existen en solo movil
                if (item && !forms.fibra && !this.rmGlobals.mobileRateIsValid(item, this.rates)) {
                    item.rate = null;
                }
                // Miramos si la tarifa seleccionada existen para convergente
                if (item && forms.fibra) {
                    if (item.principal && (!forms.haveCoverage || !this.rmGlobals.mobileRateIsValidConvergente(this.order, item, this.rates))) {
                        item.rate = null;
                        forms.fibra = {
                            rate: null
                        };
                    }
                    if (!item.principal && !this.rmGlobals.mobileRateIsValid(item, this.rates)) {
                        item.rate = null;
                    }
                }
                let getMobilePack = this.draftService.getMobilePack(item);
                getMobilePack.iccid = '';
                mobileForms.push(getMobilePack);                 
            });
            forms.movilPacks = mobileForms;
        }

        forms.cliente = this.draftService.getUserDataFromOrder(this.order);

        this.orderService.resetOrder();
        // Convergente
        if (forms.fibra && forms.movilPacks) {
            path = this.draftService.getPath(orderType.CONVERGENT);
            this.rmService.setTypeOrder(orderType.CONVERGENT);
        }
        // Solo Fibra
        if (forms.fibra && !forms.movilPacks) {
            path = this.draftService.getPath(orderType.BROADBAND);
            this.rmService.setTypeOrder(orderType.BROADBAND);
        }
        // Solo movil
        if (!forms.fibra && forms.movilPacks) {
            path = this.draftService.getPath(orderType.MOBILE);
            this.rmService.setTypeOrder(orderType.MOBILE);
        }
        this.rmService.setFormsData(forms);
        // this.rmService.setPreventDestroy(false);
        this.activeModal.dismiss();
        this.router.navigate([path]);
        // this.router.navigate([path]).then(() => this.rmService.setPreventDestroy(false));
    }

    async copyOrderPartial(type: string) {
        const path = this.draftService.getPath(type);
        const mobileForms = [];
        const forms = {
            fibra: null,
            movilPacks: null,
            cliente: null,
            normalizador: null,
            cobertura: null,
            disabledCliente: true,
            haveCoverage: true
        };

        // Si es modo solo cliente no deshabilitamos algunos formularios del cliente
        if (this.showOptionClient) {
            forms.disabledCliente = false;
        }

        if (this.selected.elements.fibra) {
            this.loading = true;
            this.loadingText = 'Comprobando cobertura...';
            forms.haveCoverage = await this.rmGlobals.coverageIsValid(this.order.broadband, this.roadTypes);
            if (forms.haveCoverage) {
                forms.fibra = {
                    rate: this.rmGlobals.ftthRateIsValid(this.order, this.rates) ? this.draftService.getRate(this.order.broadband.rate) : null
                };
            } else {
                forms.fibra = {
                    rate: null
                };
            }
            forms.normalizador = this.draftService.getNormalizador(this.order.broadband);
            forms.cobertura = this.draftService.getCobertura(this.order.broadband);
        }

        if (this.selected.elements.movil.find(x => x === true)) {
            this.selected.elements.movil.forEach((element, index) => {
                if (element) {
                    // Miramos si la tarifa seleccionada existen en solo movil
                    if (this.order.mobiles[index] && type === orderType.MOBILE && !this.rmGlobals.mobileRateIsValid(this.order.mobiles[index], this.rates)) {
                        this.order.mobiles[index].rate = null;
                    }
                    // Miramos si la tarifa seleccionada existen para convergente
                    if (this.order.mobiles[index] && type === orderType.CONVERGENT) {
                        if (this.order.mobiles[index].principal && (!forms.haveCoverage || !this.rmGlobals.mobileRateIsValidConvergente(this.order, this.order.mobiles[index], this.rates))) {
                            this.order.mobiles[index].rate = null;
                            forms.fibra = {
                                rate: null
                            };
                        }
                        if (!this.order.mobiles[index].principal && !this.rmGlobals.mobileRateIsValid(this.order.mobiles[index], this.rates)) {
                            this.order.mobiles[index].rate = null;
                        }
                    }
                    let getMobilePack = this.draftService.getMobilePack(this.order.mobiles[index]);
                    getMobilePack.iccid = '';
                    mobileForms.push(getMobilePack);
                }
            });
            forms.movilPacks = mobileForms;
        }

        if (this.selected.elements.cliente) {
            forms.cliente = this.draftService.getUserDataFromOrder(this.order);
        }

        this.orderService.resetOrder();
        this.rmService.setTypeOrder(this.order.type);
        this.rmService.setFormsData(forms);
        // this.rmService.setPreventDestroy(false);
        this.activeModal.dismiss();
        this.router.navigate([path]);
        // this.router.navigate([path]).then(() => this.rmService.setPreventDestroy(false));
    }

    changeOptions() {
        const found = this.selected.elements.movil.find(x => x === true);
        this.showConvergente = this.showMovil = this.showFibra = false;
        this.anyRateInvalid = false;

        // Fibra y movil
        if (this.selected.elements.fibra && found) {
            this.showConvergente = true;
            this.anyRateInvalidOrder(orderType.CONVERGENT);
        }

        // Solo fibra
        if (this.selected.elements.fibra && !found) {
            this.showFibra = true;
            this.anyRateInvalidOrder(orderType.BROADBAND);
        }

        // Solo movil
        if (!this.selected.elements.fibra && found) {
            this.showMovil = true;
            this.anyRateInvalidOrder(orderType.MOBILE);
        }
        
        // Nada seleccionado
        if (!this.selected.elements.fibra && !found) {
            this.anyRateInvalidOrder(this.order.type);
        }
    }

    priceWithIVA(num) {
        return priceWithIVA(num)
    }

    anyRateInvalidOrder(type) {
        this.anyRateInvalid = false;
        if (type === orderType.CONVERGENT) {
            this.order.broadband.isValidRate = this.rmGlobals.ftthRateIsValid(this.order, this.rates);
            this.anyRateInvalid = !this.order.broadband.isValidRate;
            this.order.mobiles.forEach((movil) => {
                movil.isValidRate = this.rmGlobals.mobileRateIsValidConvergente(this.order, movil, this.rates);
                if (!movil.isValidRate) {
                    this.anyRateInvalid = true;
                }
            });
        }

        if (type === orderType.BROADBAND) {
            this.order.broadband.isValidRate = this.rmGlobals.ftthRateIsValid(this.order, this.rates);
            this.anyRateInvalid = !this.order.broadband.isValidRate;
        }

        if (type === orderType.MOBILE) {
            this.order.mobiles.forEach((movil) => {
                movil.isValidRate = this.rmGlobals.mobileRateIsValid(movil, this.rates);
                if (!movil.isValidRate) {
                    this.anyRateInvalid = true;
                }
            });
        }
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
